











































































import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import MStoreTable from '@/components/shared/Table/MStoreTable.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import MStoreFormSelect from '@/components/shared/MStoreFormSelect.vue';
import {
  ArenaSignSignerRoleModel,
  ArenaSignSignerRolesConfigurationModel,
  DocumentTypeModel,
  ArenaSignSignerRoleSearchModel,
  StickySettingsActions,
  StickyStoreNames,
  StickySettingsGetters,
  StickySettingsFields,
  StickyTableStateFields
} from '@/types';
import { RouteRegEx } from '@/types/enums';
import { ScriveConfigurationService } from '@/services/scrive/ScriveConfigurationService';
import { ComponentHelper, MTablehelper, RouteHelpers, confirmationHelper } from '@/mixins';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';

export default Vue.extend({
  name: 'ScriveSignerRoleManagement',
  mixins: [ComponentHelper, MTablehelper, RouteHelpers, confirmationHelper],
  data() {
    return {
      pageIsLoading: true,
      isLoading: false,
      fields: [
        {
          description: {
            label: 'Signer Role Description',
            sortable: true
          }
        },
        {
          key: 'actions',
          label: '',
          sortable: false
        }
      ],
      items: [] as ArenaSignSignerRoleModel[],
      hasError: false,
      errorMessage: '',
      documentTypes: [] as DocumentTypeModel[],
      scriveSignerRolesConfiguration: {} as ArenaSignSignerRolesConfigurationModel
    };
  },
  methods: {
    ...mapActions(StickyStoreNames.ScriveSignerRoleManagement, [
      StickySettingsActions.SetStickyStateField,
      StickySettingsActions.ResetStickyState
    ]),
    async getData(this: any) {
      this.isLoading = true;
      this.scriveSignerRolesConfiguration = await ScriveConfigurationService.getSignerRolesConfigurationAsync({
        documentTypeId: this.documentTypeId
      } as ArenaSignSignerRoleSearchModel);
      this.items = this.scriveSignerRolesConfiguration.signerRoles;
      this.documentTypes = this.scriveSignerRolesConfiguration.documentTypes;
      this.isLoading = false;
    },
    navigateToEditSignerRole(this: any, id: number) {
      const param = {} as { [index: string]: any };
      param.documentTypeId = this.documentTypeId;
      param.id = id;
      this.onTableStateFieldUpdated('selectedPk', id);
      this.$router.push({
        name: 'scriveEditSignerRole',
        params: param
      });
    },
    navigateToAddSgnerRole(this: any) {
      const param = {} as { [index: string]: any };
      param.documentTypeId = this.documentTypeId;
      this.$router.push({
        name: 'scriveAddSignerRole',
        params: param
      });
    },
    async deleteSignerRole(this: any, id: number) {
      await this.hasDeleteConfirmedAsync(this.$bvModal, 'Are you sure you want to delete the Signer Role?').then(
        async (result: boolean) => {
          if (result) {
            try {
              this.isLoading = true;
              await ScriveConfigurationService.deleteSignerRoleAsync(id);
              SnotifyConfiguration.showSuccess('Signer Role deleted successfully.');
              await this.getData();
            } catch (error) {
              this.$log('Error deleting Signer Role');
            } finally {
              this.isLoading = false;
            }
          }
        }
      );
    },
    onTableStateFieldUpdated(this: any, field: string, value: any) {
      this.setStickyStateField({
        field: `tableState.${field}`,
        value
      });
    },
    resetViewState(this: any) {
      const canKeepState = this.canKeepState(RouteRegEx.ScriveSignerRoles);
      if (!canKeepState) {
        this.resetStickyState();
      }
    },
    async initialise(this: any) {
      try {
        this.pageIsLoading = true;
        this.resetViewState();
        await this.getData();
      } catch (error) {
        this.handleError(error);
      } finally {
        this.pageIsLoading = false;
      }
    }
  },
  computed: {
    ...mapGetters(StickyStoreNames.ScriveSignerRoleManagement, [StickySettingsGetters.GetStickyStateField]),
    getDocumentTypeId(this: any): number | null {
      return this.getStickyStateField ? this.getStickyStateField(StickySettingsFields.DocumentTypeId) : null;
    },
    documentTypeId: {
      get(this: any): number | null {
        const documentTypeId = this.getDocumentTypeId;
        if (documentTypeId !== null) {
          return documentTypeId;
        }
        return this.scriveSignerRolesConfiguration?.documentTypeId;
      },
      set(this: any, value: any) {
        this.setStickyStateField({ field: StickySettingsFields.DocumentTypeId, value });
      }
    },
    stickyTableStateFields() {
      return StickyTableStateFields;
    }
  },
  watch: {
    async documentTypeId(this: any, documentTypeId: number | undefined, previousDocumentTypeId) {
      if (previousDocumentTypeId == null) {
        return;
      }
      this.getData();
    }
  },
  components: {
    MStoreTable,
    LoadingSpinner,
    MStoreFormSelect
  },
  mounted() {
    this.initialise();
  }
});
